var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _ellipse, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _ellipse2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHowToPlayPinkMonster2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 235,
    height: 229,
    viewBox: "0 0 235 229",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M73.5471 169.497C73.0387 175.792 67.5256 180.484 61.2303 179.977C54.9351 179.471 50.2421 173.958 50.749 167.663C51.259 161.369 59.5477 122.207 65.8414 122.714C72.1366 123.222 74.0524 163.204 73.5471 169.497",
    fill: "#DB1375"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M70.3352 168.62C69.9613 173.247 65.909 176.697 61.2805 176.326C56.6538 175.952 53.2056 171.899 53.578 167.272C53.9506 162.644 60.0452 133.862 64.6705 134.233C69.2989 134.606 70.7077 163.993 70.3352 168.62",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M64.3578 154.483C61.4261 148.713 59.1283 143.293 57.4351 138.184C56.9115 139.889 56.4033 141.659 55.9155 143.445C57.6156 148.041 59.7451 152.859 62.3177 157.922C65.0767 163.351 68.4334 168.753 72.2176 173.984C72.9607 172.62 73.4392 171.084 73.5726 169.435C73.5738 169.421 73.5737 169.4 73.5777 169.385C70.0473 164.536 66.9194 159.524 64.3578 154.483",
    fill: "#B21F5B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M187.286 111.7C192.668 115.002 199.712 113.314 203.013 107.931C206.313 102.548 204.627 95.5062 199.243 92.2061C193.86 88.9067 157.342 72.5138 154.042 77.8949C150.741 83.2794 181.903 108.399 187.286 111.7",
    fill: "#DB1375"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M188.474 108.589C192.431 111.014 197.608 109.774 200.033 105.82C202.46 101.861 201.221 96.6859 197.264 94.259C193.307 91.8314 166.463 79.7855 164.036 83.7421C161.61 87.6982 184.517 106.162 188.474 108.589",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M180.576 95.4268C177.645 89.6573 174.622 84.605 171.49 80.2273C173.178 80.8092 174.909 81.4405 176.638 82.1003C179.347 86.184 181.986 90.743 184.558 95.8057C187.317 101.235 189.698 107.133 191.693 113.273C190.153 113.069 188.631 112.549 187.222 111.684C187.21 111.677 187.191 111.666 187.177 111.659C185.341 105.95 183.138 100.468 180.576 95.4268",
    fill: "#B21F5B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M152.011 55.4903C148.255 62.6984 142.823 67.2978 139.874 65.7652C136.929 64.228 137.584 57.1418 141.34 49.9324C145.095 42.7223 150.527 38.1221 153.474 39.6574C156.421 41.1892 155.765 48.2781 152.011 55.4903",
    fill: "#DB1375"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M155.24 68.2466C147.977 71.9017 140.881 72.4582 139.387 69.4897C137.894 66.5226 142.571 61.1545 149.833 57.5001C157.094 53.8458 164.192 53.2886 165.685 56.2578C167.178 59.2249 162.502 64.5923 155.24 68.2466",
    fill: "#DB1375"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M129.031 54.6003C130.201 62.6429 133.81 68.7793 137.101 68.3011C140.389 67.8202 142.106 60.9129 140.939 52.8698C139.767 44.8259 136.158 38.6895 132.867 39.1692C129.579 39.6486 127.859 46.5564 129.031 54.6003",
    fill: "#DB1375"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5689 108.053C56.6035 109.269 63.523 107.593 64.0234 104.309C64.518 101.023 58.4079 97.3746 50.3703 96.1581C42.3314 94.9399 35.4151 96.6151 34.916 99.9007C34.4171 103.185 40.5302 106.834 48.5689 108.053",
    fill: "#DB1375"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M56.9673 118.184C64.2016 114.472 68.8362 109.068 67.3178 106.112C65.8015 103.156 58.7097 103.768 51.4754 107.48C44.2425 111.191 39.6078 116.596 41.1262 119.552C42.6425 122.507 49.7344 121.895 56.9673 118.184",
    fill: "#DB1375"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M61.394 88.9684C67.2008 94.6568 70.0284 101.189 67.7035 103.564C65.3775 105.938 58.7841 103.252 52.9773 97.5658C47.1705 91.8774 44.3429 85.3452 46.6689 82.9715C48.9938 80.5966 55.5861 83.2811 61.394 88.9684",
    fill: "#DB1375"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M180.251 93.917C160.455 54.9589 135.78 55.139 96.8158 74.9385C57.8556 94.7359 43.1601 114.562 62.9565 153.52C77.1852 181.521 112.316 208.523 127.995 200.772C140.546 194.567 134.671 185.61 149.291 178.208C163.724 170.904 167.265 182.024 178.602 176.152C198.267 165.965 195.743 124.403 180.251 93.917",
    fill: "#DB1375"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M161.252 60.5117C160.043 58.1122 154.604 58.3733 148.765 60.9912C148.98 60.6196 149.19 60.2352 149.394 59.8453C152.653 53.5945 153.22 47.4476 150.664 46.1159C148.11 44.785 143.397 48.7758 140.14 55.0273C139.937 55.4185 139.745 55.8089 139.563 56.198C138.362 49.9139 135.458 45.307 132.797 45.6953C129.944 46.1093 128.457 52.0998 129.468 59.0754C130.483 66.0509 133.616 71.3687 136.466 70.9548C137.442 70.8132 138.259 70.0179 138.868 68.7546L138.874 68.7566C138.201 69.9606 138.017 71.0642 138.429 71.9371C128.414 72.5812 116.655 77.5887 101.958 85.0567C87.6951 92.3045 76.9348 98.6837 70.4418 106.101C69.9232 105.429 69.0009 105.022 67.7969 104.876C67.7969 104.876 67.7989 104.873 67.7982 104.872C67.7982 104.872 67.8002 104.869 67.7995 104.868C69.1788 105.121 70.3031 104.929 70.9928 104.225C73.0099 102.165 70.5591 96.5008 65.5229 91.5689C60.486 86.6391 54.7696 84.3086 52.7532 86.369C50.8731 88.2887 52.8812 93.3503 57.2473 98.0263C56.827 97.9435 56.3972 97.8689 55.9613 97.8024C48.9917 96.7475 42.9927 98.1996 42.5594 101.049C42.1295 103.897 47.4301 107.063 54.3976 108.117C54.8328 108.182 55.2673 108.239 55.6928 108.285C50.1356 111.458 46.7196 115.697 47.9449 118.088C49.2596 120.652 55.4113 120.12 61.6848 116.902C62.8764 116.29 63.9875 115.626 64.9972 114.931C61.6176 123.844 63.2976 134.702 70.9356 149.733C88.524 184.346 114.371 195.189 148.984 177.601C183.597 160.012 190.077 132.742 172.488 98.1291C164.787 82.9735 156.943 75.2111 147.652 72.7497C149.111 72.3027 150.647 71.6861 152.196 70.9091C158.492 67.7407 162.546 63.0858 161.252 60.5117",
    fill: "white"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 122.09,
    cy: 124.776,
    rx: 61.2441,
    ry: 57.1744,
    transform: "rotate(-26.9372 122.09 124.776)",
    fill: "url(#paint0_radial_14398_113922)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M123.9 128.268C106.845 136.934 87.8166 132.7 76.9149 126.012C84.8821 134.171 106.729 141.937 125.897 132.197C144.916 122.533 151.67 100.093 149.748 88.8663C148.709 101.655 140.824 119.668 123.9 128.268",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M123.637 127.749C106.581 136.416 87.5538 132.183 76.6514 125.494C84.6193 133.653 106.467 141.421 125.635 131.681C144.654 122.017 151.407 99.5741 149.485 88.349C148.446 101.138 140.561 119.149 123.637 127.749",
    fill: "#6D0F0F"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M135.42 58.6758C145.621 78.752 137.217 103.502 116.642 113.957C96.0714 124.41 71.1214 116.609 60.9198 96.5325C50.7182 76.4563 59.1263 51.7042 79.6971 41.2512C100.272 30.7962 125.218 38.5997 135.42 58.6758",
    fill: "#DB1375"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M129.659 60.9489C138.569 78.4836 131.576 99.9219 114.04 108.833C96.5037 117.744 75.0648 110.753 66.1546 93.2181C57.2445 75.6835 64.2373 54.2452 81.7734 45.3343C99.3096 36.4234 120.749 43.4143 129.659 60.9489Z",
    fill: "url(#paint1_radial_14398_113922)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120.434 65.6344C126.754 78.0735 121.794 93.2818 109.354 99.6032C96.9135 105.925 81.7047 100.965 75.3839 88.5262C69.063 76.0871 74.0237 60.8788 86.4638 54.5574C98.904 48.236 114.113 53.1954 120.434 65.6344Z",
    fill: "url(#paint2_radial_14398_113922)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M108.442 71.7288C111.399 77.5484 109.079 84.6612 103.259 87.6187C97.4385 90.5761 90.3256 88.2567 87.3684 82.4371C84.4119 76.6188 86.7312 69.5047 92.5514 66.5473C98.3715 63.5898 105.485 65.9106 108.442 71.7288",
    fill: "#49482A"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M170.086 140.503C174.646 149.477 164.127 163.975 146.59 172.886C129.057 181.796 111.141 181.746 106.582 172.773C102.024 163.802 112.545 149.302 130.079 140.392C147.615 131.481 165.528 131.533 170.086 140.503",
    fill: "white"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 92.2507,
    cy: 65.9568,
    rx: 14.0663,
    ry: 10.8071,
    transform: "rotate(-26.9372 92.2507 65.9568)",
    fill: "url(#paint3_radial_14398_113922)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_14398_113922",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(122.09 118.983) rotate(90) scale(62.8563 57.4768)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.224916,
    stopColor: "#E4E4E4",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.521135,
    stopColor: "#C57730",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_14398_113922",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(97.9068 77.083) rotate(-26.9372) scale(35.6162 35.6132)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#D6D6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C6C6C6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_14398_113922",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(97.9085 77.081) rotate(-26.9372) scale(25.2662 25.264)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9757EE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_14398_113922",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(92.2507 88.7109) rotate(-90) scale(33.5612 43.6824)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.401042,
    stopColor: "#2E2A49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.546875,
    stopColor: "#2E2A49",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.645833,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.760417,
    stopColor: "#B0C5FB",
    stopOpacity: 0.33
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984375,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHowToPlayPinkMonster2);
export default __webpack_public_path__ + "static/media/HowToPlay_PinkMonster2.d3139d26d9657e98aac10c60e0b13c9a.svg";
export { ForwardRef as ReactComponent };